import React from 'react';

export const VisaIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.8877 14.8213L9.94927 8.73096H11.647L10.5848 14.8213H8.8877Z"
      fill="#004F8B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.7424 8.88073C16.406 8.7573 15.879 8.625 15.2207 8.625C13.5432 8.625 12.3614 9.451 12.3513 10.6348C12.3419 11.5099 13.195 11.9982 13.839 12.2895C14.4998 12.5879 14.7221 12.7783 14.7188 13.0449C14.7147 13.4531 14.1911 13.6397 13.7031 13.6397C13.0236 13.6397 12.6626 13.5474 12.1051 13.32L11.8862 13.2232L11.6479 14.5865C12.0446 14.7565 12.7779 14.9039 13.5391 14.9115C15.3239 14.9115 16.4824 14.0949 16.4956 12.8307C16.5021 12.1379 16.0496 11.6106 15.0702 11.176C14.4767 10.8943 14.1133 10.7062 14.1171 10.421C14.1171 10.1678 14.4247 9.89713 15.0894 9.89713C15.6446 9.88873 16.0467 10.007 16.3601 10.1305L16.5122 10.2007L16.7424 8.88073Z"
      fill="#004F8B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.0959 8.73682H19.784C19.3776 8.73682 19.0735 8.8452 18.895 9.24187L16.3735 14.8233H18.1564C18.1564 14.8233 18.4479 14.0728 18.5139 13.9081C18.7087 13.9081 20.4405 13.9106 20.6881 13.9106C20.7389 14.1238 20.8947 14.8233 20.8947 14.8233H22.4701L21.0959 8.73682ZM19.0025 12.6623C19.1428 12.3114 19.6789 10.9598 19.6789 10.9598C19.6687 10.976 19.8183 10.6072 19.9039 10.3785L20.0187 10.9037C20.0187 10.9037 20.3438 12.3574 20.4117 12.6623H19.0025Z"
      fill="#004F8B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.46364 8.73535L5.80142 12.8886L5.62435 12.0445C5.31496 11.0715 4.35087 10.0174 3.27295 9.48972L4.79282 14.816L6.58916 14.814L9.26201 8.73535H7.46364Z"
      fill="#004F8B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.25935 8.73145H1.52172L1.5 8.85815C3.62995 9.36226 5.03922 10.5805 5.62423 12.0443L5.02895 9.2456C4.9261 8.8599 4.62805 8.74486 4.25935 8.73145Z"
      fill="#ED9F2D"
    />
  </svg>
);
